import { render, staticRenderFns } from "./PerPageDropdown.vue?vue&type=template&id=7c39b3ac&"
import script from "./PerPageDropdown.vue?vue&type=script&lang=js&"
export * from "./PerPageDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports